import { TemplateVersion } from "components/TemplateEditor/Components/VersionHistory/Constants";
import { ITemplate } from "interfaces";
import _, { isArray } from "lodash";

/**
 * @description update template name of current template in the templates list
 * @param {Array<ITemplate>} templates template list
 * @param {ITemplate} selectedTemplate current template
 * @returns {Array<ITemplate>} - modified templates list
 */
export const updateTemplateList = (
  templates: Array<ITemplate>,
  selectedTemplate: ITemplate
): Array<ITemplate> => {
  try {
    if (isArray(templates)) {
      return templates.map((template) =>
        template.templateId === selectedTemplate.templateId
          ? { ...template, templateName: selectedTemplate.templateName }
          : template
      );
    } else {
      return templates;
    }
  } catch (error) {
    return templates;
  }
};

/**
 * @description update versions with new attribute and sort by version desc
 * @param {Array<IVersion>} versions version list
 * @returns {Array<IVersion>} - modified versions list
 */
export const updateVersions = (
  versions: Array<TemplateVersion>
): Array<TemplateVersion> => {
  try {
    if (isArray(versions)) {
      return versions
        .sort((a, b) => b.versionNo - a.versionNo) // Sort by descending order of versionNo
        .map((version, index) => ({
          ...version,
          isSelected: index === 0, // Set isSelected to true for the first element, false for others
        }));
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

/**
 * @description get new template version
 * @param {Array<TemplateVersion>} versions version list
 * @param {any} template parsed template
 * @returns {number} - new template version
 */
export const getUpdatedVersion = (
  versions: Array<TemplateVersion>,
  template: any
): number => {
  try {
    if (isArray(versions) && versions?.length > 1) {
      return versions[0]?.versionNo + 1;
    } else {
  return Number(template.templateContent?.versionNo ?? 0) + 1;
    }
  } catch (error) {
    return 1;
  }
};
